const EVENTS = {
  SIDE_MENU_COLLAPSE: 'ui.action.menu.collapse',
  SIDE_MENU_EXPAND: 'ui.action.menu.expand',
  CLOSE_MENU: 'ui.action.close_menu',
  DISABLE_SPINNER: 'ui.global_spinner.disable',
  ENABLE_SPINNER: 'ui.global_spinner.enable',
  NAVIGATE: 'navigate',
} as const;

function dataEventBusMap(resourceName: string) {
  return {
    load: `data.${resourceName}.load`,
    success: `data.${resourceName}.success`,
    error: `data.${resourceName}.error`,
  };
}

export const API_EVENTS = {
  token: dataEventBusMap('token'),
};

export default EVENTS;
